import React, {useState, useEffect} from 'react';
import AppConstants from "../../Config/AppConstants";
//import useWindowSize from './UseWindowSize';

function BoxAds(props) {

   // return <p>ưqewqe</p>;
  //  const [showIframeAds, setShowIframeAds] = useState(true);
  //   const size = useWindowSize();
  //   let widthScreen = size.width;
    // useEffect(() => {
    //     adsPromise();
    // },[])
    //
    // const adsPromise = async () => {
    //     await new Promise(resolve => setTimeout(resolve, 3000));
    //     setShowIframeAds(true)
    // }
    //
    // if (!showIframeAds) {
    //     return <></>;
    // }
    return <>
        <div className='boxAds'>
            <iframe
                src={`/iframe.html`}
                width="300"
                height="100"
                scrolling="no"
                marginWidth="0"
                marginHeight="0"
                frameBorder="0"
                role="none"
                aria-label={AppConstants.pageName}
            />
        </div>
    </>

    return (
        <div className='boxAds'>
            {
                (!widthScreen || widthScreen <= 768) ?
                    <iframe
                        src={`/iframe.html`}
                        width="300"
                        height="100"
                        scrolling="no"
                        marginWidth="0"
                        marginHeight="0"
                        frameBorder="0"
                    role="none"
                    aria-label={AppConstants.pageName}
                /> : <iframe
                        src={`/iframepc.html`}
                        width="300"
                        height="100"
                        scrolling="no"
                        marginWidth="0"
                        marginHeight="0"
                        frameBorder="0"
                        role="none"
                        aria-label={AppConstants.pageName}
                    />
            }
        </div>
    );
}

export default BoxAds;
